import { motion, AnimatePresence } from 'framer-motion';
import { useState, useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/24/solid';

const STORAGE_KEY = 'mobile-banner-dismissed';

const MobileBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Check if banner was already dismissed in this session
    const dismissed = sessionStorage.getItem(STORAGE_KEY);
    if (!dismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    setIsDismissed(true);
    sessionStorage.setItem(STORAGE_KEY, 'true');
  };

  return (
    <AnimatePresence>
      {isVisible && !isDismissed && (
        <motion.div
          initial={{ opacity: 0, y: -10, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -10, scale: 0.95 }}
          transition={{ duration: 0.3, ease: [0.25, 0.1, 0.25, 1] }}
          className="md:hidden fixed top-20 right-4 z-[999] max-w-[280px]"
        >
          <div className="relative rounded-2xl bg-gradient-to-br from-teal-600/90 via-cyan-600/90 to-blue-600/90 backdrop-blur-md border border-white/20 shadow-[0_8px_32px_rgba(0,109,109,0.3)] px-4 py-3 pr-10">
            <button
              onClick={handleDismiss}
              className="absolute top-2 right-2 p-1 rounded-full hover:bg-white/20 transition-colors"
              aria-label="Dismiss banner"
            >
              <XMarkIcon className="w-4 h-4 text-white/90" />
            </button>
            <p className="text-sm text-white font-medium leading-relaxed">
              Tap <span className="font-semibold">☰</span> to explore{' '}
              <span className="font-semibold">Longevity</span>
            </p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MobileBanner;

